import React, { useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import { SectionCard, Field, TextInput, SaveRow, AddButton, EmptyHint, palette } from './ui';
import { LANGUAGE_SUGGESTIONS } from './constants';

const EMPTY_FORM = { name: '', can_speak: true, can_read: false, can_write: false };

function LanguageForm({ isDarkMode, onSave, onCancel }) {
  const c = palette(isDarkMode);
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!form.name.trim()) return;
    setSaving(true);
    const ok = await onSave({ ...form, name: form.name.trim() });
    setSaving(false);
    if (ok) onCancel();
  };

  const check = (key, label) => (
    <label className="flex items-center gap-2 text-sm">
      <input type="checkbox" checked={form[key]} onChange={e => setForm(f => ({ ...f, [key]: e.target.checked }))} className="h-4 w-4" />
      {label}
    </label>
  );

  return (
    <div className="mt-3 space-y-3">
      <Field label="Language *">
        <TextInput isDarkMode={isDarkMode} value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} list="language-suggestions" placeholder="e.g. Hindi" />
        <datalist id="language-suggestions">
          {LANGUAGE_SUGGESTIONS.map(l => <option key={l} value={l} />)}
        </datalist>
      </Field>
      <div className={`flex gap-5 ${c.text}`}>
        {check('can_speak', 'Speak')}
        {check('can_read', 'Read')}
        {check('can_write', 'Write')}
      </div>
      <SaveRow isDarkMode={isDarkMode} onSave={save} onCancel={onCancel} saving={saving} saveLabel="Add" />
    </div>
  );
}

export default function LanguagesCard({ isDarkMode, items, actions }) {
  const c = palette(isDarkMode);
  const [adding, setAdding] = useState(false);

  const abilities = (l) =>
    [l.can_speak && 'Speak', l.can_read && 'Read', l.can_write && 'Write'].filter(Boolean).join(', ');

  return (
    <SectionCard id="languages" title="Languages" isDarkMode={isDarkMode}>
      {items.length === 0 && !adding && (
        <EmptyHint isDarkMode={isDarkMode}>Which languages can you speak, read or write?</EmptyHint>
      )}
      <ul className="space-y-2">
        {items.map(l => (
          <li key={l.id} className="flex items-center justify-between gap-3">
            <div>
              <span className={`text-sm font-medium ${c.text}`}>{l.name}</span>
              <span className={`text-sm ml-2 ${c.secondaryText}`}>{abilities(l)}</span>
            </div>
            <button onClick={() => actions.remove(l.id)} aria-label={`Remove ${l.name}`} className={`p-2 rounded-full ${c.hover} text-red-500`}>
              <FaTrash className="h-3.5 w-3.5" />
            </button>
          </li>
        ))}
      </ul>
      {adding ? (
        <LanguageForm isDarkMode={isDarkMode} onSave={(data) => actions.add(data)} onCancel={() => setAdding(false)} />
      ) : (
        <div className="mt-3">
          <AddButton isDarkMode={isDarkMode} label="Add language" onClick={() => setAdding(true)} />
        </div>
      )}
    </SectionCard>
  );
}
